/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Dialog,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import QrCodeIcon from '@mui/icons-material/QrCode';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import NavbarPaymentOptions from '../components/Navbar/NavbarPaymentOptions';
import QRCodePopUP from '../components/PayOptions/QRCodePopUp';
import QRCode from '../components/PayOptions/QRCode';
import QRCredit from '../components/PayOptions/QRCredit';
import CreditCardPopUp from '../components/PayOptions/CreditCardPopUp';
import QRAllInOne from '../components/PayOptions/QRAllInOne';
import InternetBankingPopup from '../components/PayOptions/InternetBanking';
import CreditCardPopup from '../components/PayOptions/CreditCard';
import BankTransferPopup from '../components/PayOptions/BankTransfer';
import MobileBankingPopup from '../components/PayOptions/MobileBanking';
import WalletPopup from '../components/PayOptions/Wallet';
import InstallmentPopup from '../components/PayOptions/Installment';
import RecurringPopup from '../components/PayOptions/Recurring';
import ETaxPopup from '../components/PayOptions/Etax';
import CreditCardImage from '../assets/images/CreditCardImage.png';
import WalletImage from '../assets/images/WalletImage.png';
import InstallmentImage from '../assets/images/InstallmentImage.png';
// import RecurringImage from '../assets/images/RecurringImage .png';
import pciImage from '../assets/images/pci.png';
import bankofthailandImage from '../assets/images/bankofthailand.jpg';
import api from '../utils/functions/api';
import thailandFlag from '../assets/images/thai.avif';
import ukFlag from '../assets/images/uk.webp';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import Loading from '../components/Loading';
import { get, set } from 'lodash';

function PaymentOptions() {
  const [isLoading, setIsLoading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isDisablePay, setIsDisablePay] = useState(true); // Updated initial state to true
  const [eTaxStatus, setETaxStatus] = useState('');
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [bank, setBank] = useState('');
  const [payType, setPayType] = useState('');
  const [maintenancePage, setMaintenancePage] = useState(false);
  const [companyImage, setCompanyImage] = useState('');
  const [companyBankImage, setCompanyBankImage] = useState('');
  const [orderId, setOrderId] = useState('');
  const [fee, setFee] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [callCompany, setCallCompany] = useState('');
  const [cardStatus, setCardStatus] = useState('');
  const [crCard, setCrCard] = useState([]);
  const [backgroundColor, setBackgroundColor] = useState('');
  const [eTaxPDF, setETaxPDF] = useState('');
  const [subtotal, setSubtotal] = useState('');
  const [vat, setVat] = useState('');
  const [wht, setWht] = useState('');
  const [total, setTotal] = useState('');
  const [etaxData, setETaxData] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTermsOpen, setDialogTermsOpen] = useState(false);
  const [tempETaxChecked, setTempETaxChecked] = useState(false);
  const theme = useTheme();
  const isXsOrMd = useMediaQuery(theme.breakpoints.down('md'));
  const checkInterval = useRef(null);
  const urlMerchant = useRef('');
  const formMerchant = useRef('');
  const [checkQR, setCheckQR] = useState([]);
  const [checkCredit, setCheckCredit] = useState([]);
  const [timeExpired, setTimeExpired] = useState('');
  const [timeLeft, setTimeLeft] = useState('');
  const [isExpired, setIsExpired] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const tokens = new URLSearchParams(location.search).get('authorization');

  const [language, setLanguage] = useState('EN'); // 'EN' or 'TH'
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
    // ใส่ logic ที่ต้องการเมื่อเปลี่ยนภาษา
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get(`${process.env.REACT_APP_APIHOST}/data`, {
        headers: {
          Authorization: `${tokens}`,
        },
      });
      setIsLoading(false);
      if (!data || !data.status) {
        console.error('Invalid data received from API');
        return;
      }

      if (data.status === 'unpaid') {
        if (data.etax === 'true' && !data.source.total) {
          setIsDisablePay(true);
          alert('Invalid VAT field. Please check it again.');
        }
        if (data?.policy === 'on') {
          setDialogTermsOpen(true);
        }
        setLanguage(data.language || 'TH');
        setETaxStatus(data.etax);
        setPaymentMethods(data.paymentMethods);
        setBank(data.paymentMethods[0].banks[0].bankName);
        setMaintenancePage(true);
        setCompanyImage(data.company_image);
        setCompanyBankImage(data.company_bank_image);
        setOrderId(data.source.id);
        setFee(data.fee);
        setTotalAmount(data.total_amount);
        setCompanyName(data.company_name);
        setCallCompany(data.company_callback);
        setCardStatus(data.card_status);
        setCrCard(data.cards);
        setBackgroundColor(data.backgroundColor);
        setETaxPDF(data.eTaxPDF);
        setBankImage(data.bank_image);
        setNameAccount(data.account_name);
        setAccuontNumber(data.account_number);
        setTimeExpired(data.expired_datetime);

        console.log('timeExpired', timeExpired);

        if (data.source.subtotal) {
          setSubtotal(parseFloat(data.source.subtotal).toFixed(2));
        }
        if (data.source.vat) {
          setVat(parseFloat(data.source.vat).toFixed(2));
        }
        if (data.source.wht) {
          setWht(parseFloat(data.source.wht).toFixed(2));
        }
        setTotal(data.source.total);
      } else if (data.status === 'paid' && data.company_callback) {
        navigate(
          `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'paid' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'success' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending') {
        navigate('/transactionResult?status=pending');
      } else if (data.status === 'cancel' && !data.company_callback) {
        navigate('/transactionResult?status=cancel');
      } else if (data.status === 401) {
        navigate(`/httpStatus?code=401&detail=${data.detail}`);
      }
      console.log('data', data);
      if (
        data.paymentMethods?.length === 1 &&
        data.paymentMethods[0].banks[0].name === 'QR Code' &&
        data.paymentMethods[0].banks?.length === 1
      ) {
        setPayType(data.paymentMethods[0].banks[0].payType);
        setSelectedOption(data.paymentMethods[0].banks[0].name);
        setFee(data.paymentMethods[0].banks[0].fee);
        setTotal(data.paymentMethods[0].banks[0].total);
        setTotalAmount(data.paymentMethods[0].banks[0].total_amount);
      } else if (
        data.paymentMethods?.length === 1 &&
        data.paymentMethods[0].banks?.length === 1 &&
        data.paymentMethods[0].banks[0].name === 'QR Code - SCB'
      ) {
        setPayType(data.paymentMethods[0].banks[0].payType);
        setSelectedOption(data.paymentMethods[0].banks[0].name);
        setFee(data.paymentMethods[0].banks[0].fee);
        setTotal(data.paymentMethods[0].banks[0].total);
        setTotalAmount(data.paymentMethods[0].banks[0].total_amount);
      } else if (
        data.paymentMethods?.length === 1 &&
        data.paymentMethods[0].banks[0].name === 'QR Code Credit Card' &&
        data.paymentMethods[0].banks?.length === 1
      ) {
        setPayType(data.paymentMethods[0].banks[0].payType);
        setSelectedOption(data.paymentMethods[0].banks[0].name);
        setFee(data.paymentMethods[0].banks[0].fee);
        setTotal(data.paymentMethods[0].banks[0].total);
        setTotalAmount(data.paymentMethods[0].banks[0].total_amount);
      } else if (
        data.paymentMethods?.length === 1 &&
        data.paymentMethods[0].banks[0].name ===
          'QR Code PromptPay Credit Card' &&
        data.paymentMethods[0].banks?.length === 1
      ) {
        setPayType(data.paymentMethods[0].banks[0].payType);
        setSelectedOption(data.paymentMethods[0].banks[0].name);
        setFee(data.paymentMethods[0].banks[0].fee);
        setTotal(data.paymentMethods[0].banks[0].total);
        setTotalAmount(data.paymentMethods[0].banks[0].total_amount);
      } else if (data.paymentMethods?.length === 1) {
        setPayType(data.paymentMethods[0].banks[0].payType);
        setSelectedOption(data.paymentMethods[0].banks[0].name);
        setFee(data.paymentMethods[0].banks[0].fee);
        setTotal(data.paymentMethods[0].banks[0].total);
        setTotalAmount(data.paymentMethods[0].banks[0].total_amount);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      if (error.message === 'Network Error') {
        navigate('/maintenance');
      } else if (
        error.response.status === 404 ||
        error.response.status === 500
      ) {
        navigate(`/httpStatus?code=${error.response.status}`);
      } else if (
        error.response.data.status === 401 &&
        error.response.data.message === 'Token expired'
      ) {
        navigate(
          `/httpStatus?code=${error.response.data.status}&detail=${error.response.data.message}`,
        );
      } else if (
        error.response.data.status === 401 &&
        error.response.data.message === 'jwt must have'
      ) {
        navigate(
          `/httpStatus?code=${error.response.data.status}&detail=${error.response.data.message}`,
        );
      }
    }
  };
  useEffect(() => {
    const isQRPayment =
      (selectedOption === 'QR Code' &&
        payType === 'QR' &&
        paymentMethods.length === 1 &&
        paymentMethods[0]?.banks?.length === 1) ||
      (selectedOption === 'QR Code' &&
        payType === 'QR-CIMB' &&
        paymentMethods.length === 1 &&
        paymentMethods[0]?.banks?.length === 1) ||
      (selectedOption === 'QR Code' &&
        payType === 'QR-SCB' &&
        paymentMethods.length === 1 &&
        paymentMethods[0]?.banks?.length === 1) ||
      (selectedOption === 'QR Code - SCB' &&
        payType === 'QR-SCB' &&
        paymentMethods.length === 1 &&
        paymentMethods[0]?.banks?.length === 1) ||
      (selectedOption === 'QR Code Credit Card' &&
        payType === 'QRCS' &&
        paymentMethods.length === 1 &&
        paymentMethods[0]?.banks?.length === 1) ||
      (selectedOption === 'QR Code PromptPay Credit Card' &&
        payType === 'QRPPCS' &&
        paymentMethods.length === 1 &&
        paymentMethods[0]?.banks?.length === 1);

    const isSmallScreenPayment = isXsOrMd && selectedOption !== '';
    if (isSmallScreenPayment && isQRPayment) {
      handlePaymentQR();
    } else {
      if (isSmallScreenPayment) {
        handlePaymentClick();
      }
      if (isQRPayment) {
        handlePaymentQR();
      }
    }
  }, [selectedOption]);

  useEffect(() => {
    getData();
  }, []);

  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [qrCreditOpen, setQrCreditOpen] = useState(false);
  const [qrAllInOneOpen, setQrAllInOneOpen] = useState(false);
  const [internetBankingPopupOpen, setInternetBankingPopupOpen] =
    useState(false);
  const [CreditCardPopupOpen, setCreditCardPopupOpen] = useState(false);
  const [creditPopupOpen, setCreditPopupOpen] = useState(false);
  const [bankTransferPopupOpen, setBankTransferPopupOpen] = useState(false);
  const [mobileBankingPopupOpen, setMobileBankingPopupOpen] = useState(false);
  const [walletPopupOpen, setWalletPopupOpen] = useState(false);
  const [installmentPopupOpen, setInstallmentPopupOpen] = useState(false);
  const [recurringPopupOpen, setRecurringPopupOpen] = useState(false);
  const [eTaxPopupOpen, setETaxPopupOpen] = useState(false);
  const [eTaxChecked, setETaxChecked] = useState(false);
  const [isTabletOrLarger, setIsTabletOrLarger] = useState(false);
  const [qrCodeImage, setQrCodeImage] = useState('');
  const [merchId, setMerchantId] = useState('');
  const [paymentRefId, setPaymentRefId] = useState('');
  const [intervalId, setIntervalId] = useState(null);
  const [bankImage, setBankImage] = useState('');
  const [nameAccount, setNameAccount] = useState('');
  const [accountNumber, setAccuontNumber] = useState('');

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrLarger(window.innerWidth >= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelectOption = (
    option,
    bank,
    payType,
    fee,
    total_amount,
    total,
  ) => {
    setSelectedOption(option);
    setBank(bank);
    setPayType(payType);
    setFee(fee);
    setTotalAmount(total_amount);
    setTotal(total);
  };

  useEffect(() => {
    // Disable the pay button if no payment method is selected
    setIsDisablePay(selectedOption === '');
  }, [selectedOption]);

  const checkPaymentRefId = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_APIHOST}/check_callback`,
        { headers: { Authorization: tokens, sub: paymentRefId } },
      );
      if (response.status === 200) {
        const { rmsg, status, tagUrl, tagInput } = response.data;
        if (rmsg === 'pending') {
          navigate(`/transactionResult?status=${rmsg}`);
        }
        if (rmsg === 'cancel') {
          clearInterval(intervalId); // Stop the interval if the payment is canceled
          navigate(`/transactionResult?status=${rmsg}`);
        }
        clearInterval(intervalId); // Stop the interval if the payment is successful
        if (status === 'call merchant') {
          clearInterval(intervalId);
          submitFormToMerchant(tagUrl, tagInput);
        } else if (status === 'call merchant jwt') {
          clearInterval(intervalId);
          submitFormToMerchant(tagUrl, tagInput);
        } else if (status === 'do not call merchant') {
          clearInterval(intervalId);
          const etaxResponse = await api.post(
            `${process.env.REACT_APP_APIHOST}/etax/signandgetdocument`,
            { paymentRef: paymentRefId },
          );
          const data2 = etaxResponse.data || '';
          if (data2.status === 'OK') {
            clearInterval(intervalId);
            const urlPDF = data2.pdfURL;
            window.location.replace(
              `/transactionResult?status=${rmsg}&urlPDF=${encodeURIComponent(
                urlPDF || '',
              )}`,
            );
          } else {
            window.location.replace(`/transactionResult?status=${rmsg}`);
          }
        }
      }
    } catch (error) {
      console.error('Error during combined API call:', error);
    }
  };

  useEffect(() => {
    return () => {
      if (checkInterval.current) {
        clearInterval(checkInterval.current);
      }
    };
  }, []);

  useEffect(() => {
    let interval;
    if (qrOpen || qrAllInOneOpen || qrCreditOpen) {
      checkPaymentRefId();
      interval = setInterval(checkPaymentRefId, 10000);
    }
    return () => clearInterval(interval);
  }, [qrOpen, qrCreditOpen, qrAllInOneOpen]);

  const cancel = async () => {
    try {
      const { data } = await api.post(
        process.env.REACT_APP_APIHOST + '/cancelpayment',
        { status: 'Cancel' },
        { headers: { Authorization: tokens } },
      );

      // Use the `current` property of the useRef to update the values
      urlMerchant.current = data.tagUrl;
      formMerchant.current = data.tagInput;
      submitFormToMerchant(urlMerchant.current, formMerchant.current);
    } catch (error) {
      console.error('Error processing back to merchant:', error);
    }
  };

  const submitFormToMerchant = (tagUrl, tagInput) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(tagInput, 'text/html');
    const inputs = doc.querySelectorAll('input');
    const form = document.createElement('form');
    form.action = tagUrl;
    form.method = 'POST';
    form.style.display = 'none';
    inputs.forEach((input) => {
      const inputElement = document.createElement('input');
      inputElement.type = 'hidden';
      inputElement.name = input.name;
      inputElement.value = input.value;
      form.appendChild(inputElement);
    });
    document.body.appendChild(form);
    form.submit();
  };

  const handlePaymentQR = async () => {
    if (payType === 'QR' || payType === 'QR-SCB' || payType === 'QR-CIMB') {
      try {
        // setIsLoading(true);
        const { data } = await api.post(
          `${process.env.REACT_APP_APIHOST}/createpayment`,
          {
            source: `${payType} ${bank} ${etaxData?.branchCode ?? ''} ${
              etaxData?.tax ?? ''
            } ${etaxData?.postalCode ?? ''}`,
            eTaxData: {
              BUYER_NAME: etaxData?.name,
              BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
              BUYER_TAX_ID: etaxData?.taxId,
              BUYER_BRANCH_ID: etaxData?.branchCode,
              BUYER_POST_CODE: etaxData?.postalCode,
              BUYER_ADDRESS_LINE1: etaxData?.address,
              BUYER_ADDRESS_LINE2: etaxData?.address2,
            },
            etaxname: etaxData?.etaxname ?? '',
            etaxaddress1: etaxData?.etaxaddress1 ?? '',
            etaxaddress2: etaxData?.etaxaddress2 ?? '',
            email: etaxData?.email ?? '',
            term: payType === 'IN' ? etaxData?.term : null,
            card_id: etaxData?.select_card?.card_id ?? '',
          },
          { headers: { Authorization: tokens } },
        );
        // setIsLoading(false);
        if (data.status === 'paid' && data.company_callback) {
          navigate(
            `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'paid' && !data.company_callback) {
          navigate(
            `/transactionResult?status=success&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && !data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'cancel' && !data.company_callback) {
          navigate(
            `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else {
          // setQrPopupOpen(true);
          setQrOpen(true);
          setQrCodeImage(data.imageQR);
          setMerchantId(data.merchantId);
          setPaymentRefId(data.paymentRefId);

          checkPaymentRefId();
        }
      } catch (error) {
        console.error('Error processing payment:', error);
      }
    } else if (payType === 'QRCS') {
      try {
        // setIsLoading(true);
        const { data } = await api.post(
          `${process.env.REACT_APP_APIHOST}/createpayment`,
          {
            source: `${payType} ${bank} ${etaxData?.branchCode ?? ''} ${
              etaxData?.tax ?? ''
            } ${etaxData?.postalCode ?? ''}`,
            eTaxData: {
              BUYER_NAME: etaxData?.name,
              BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
              BUYER_TAX_ID: etaxData?.taxId,
              BUYER_BRANCH_ID: etaxData?.branchCode,
              BUYER_POST_CODE: etaxData?.postalCode,
              BUYER_ADDRESS_LINE1: etaxData?.address,
              BUYER_ADDRESS_LINE2: etaxData?.address2,
            },
            etaxname: etaxData?.etaxname ?? '',
            etaxaddress1: etaxData?.etaxaddress1 ?? '',
            etaxaddress2: etaxData?.etaxaddress2 ?? '',
            email: etaxData?.email ?? '',
            term: payType === 'IN' ? etaxData?.term : null,
            card_id: etaxData?.select_card?.card_id ?? '',
          },
          { headers: { Authorization: tokens } },
        );
        // setIsLoading(false);
        if (data.status === 'paid' && data.company_callback) {
          navigate(
            `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'paid' && !data.company_callback) {
          navigate(
            `/transactionResult?status=success&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && !data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'cancel' && !data.company_callback) {
          navigate(
            `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else {
          // setQrPopupOpen(true);
          setQrCreditOpen(true);
          setQrCodeImage(data.imageQR);
          setMerchantId(data.merchantId);
          setPaymentRefId(data.paymentRefId);

          checkPaymentRefId();
        }
      } catch (error) {
        console.error('Error processing payment:', error);
      }
    } else if (payType === 'QRPPCS') {
      try {
        // setIsLoading(true);
        const { data } = await api.post(
          `${process.env.REACT_APP_APIHOST}/createpayment`,
          {
            source: `${payType} ${bank} ${etaxData?.branchCode ?? ''} ${
              etaxData?.tax ?? ''
            } ${etaxData?.postalCode ?? ''}`,
            eTaxData: {
              BUYER_NAME: etaxData?.name,
              BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
              BUYER_TAX_ID: etaxData?.taxId,
              BUYER_BRANCH_ID: etaxData?.branchCode,
              BUYER_POST_CODE: etaxData?.postalCode,
              BUYER_ADDRESS_LINE1: etaxData?.address,
              BUYER_ADDRESS_LINE2: etaxData?.address2,
            },
            etaxname: etaxData?.etaxname ?? '',
            etaxaddress1: etaxData?.etaxaddress1 ?? '',
            etaxaddress2: etaxData?.etaxaddress2 ?? '',
            email: etaxData?.email ?? '',
            term: payType === 'IN' ? etaxData?.term : null,
            card_id: etaxData?.select_card?.card_id ?? '',
          },
          { headers: { Authorization: tokens } },
        );
        // setIsLoading(false);
        if (data.status === 'paid' && data.company_callback) {
          navigate(
            `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'paid' && !data.company_callback) {
          navigate(
            `/transactionResult?status=success&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'pending' && !data.company_callback) {
          navigate(
            `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else if (data.status === 'cancel' && !data.company_callback) {
          navigate(
            `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
              data.eTaxPDF,
            )}`,
          );
        } else {
          // setQrPopupOpen(true);
          setQrAllInOneOpen(true);
          setQrCodeImage(data.paymentURL);
          setMerchantId(data.merchantId);
          setPaymentRefId(data.paymentRefId);
          checkPaymentRefId();
        }
      } catch (error) {
        console.error('Error processing payment:', error);
      }
    }
  };

  const handlePaymentClick = async () => {
    const qrMethod = paymentMethods?.find((method) =>
      method.payType?.startsWith('QR'),
    );
    const creditMethod = paymentMethods?.find((method) =>
      method.payType?.startsWith('CR'),
    );
    if (
      (selectedOption === 'QR Code' ||
        payType === 'QR' ||
        payType === 'QRCS' ||
        payType === 'QRPPCS') &&
      qrMethod?.banks?.length === 1
    ) {
      handlePaymentQR();
    } else {
      if (
        selectedOption === 'Credit Card' &&
        creditMethod?.banks?.length === 1
      ) {
        setCreditCardPopupOpen(true);
      } else if (selectedOption === 'Credit Card') {
        setCreditPopupOpen(true);
      } else if (selectedOption === 'Internet Banking') {
        setInternetBankingPopupOpen(true);
      } else if (
        selectedOption === 'QR Code' &&
        payType === 'QRPPCS' &&
        paymentMethods[0]?.banks?.length === 1
      ) {
        handlePaymentQR();
      } else if (selectedOption === 'Bank Transfer') {
        setBankTransferPopupOpen(true);
      } else if (selectedOption === 'Mobile Banking') {
        setMobileBankingPopupOpen(true);
      } else if (selectedOption === 'Wallet') {
        setWalletPopupOpen(true);
      } else if (selectedOption === 'Installment') {
        setInstallmentPopupOpen(true);
      } else if (selectedOption === 'Recurring') {
        setRecurringPopupOpen(true);
      } else if (
        selectedOption === 'QR Code' ||
        payType === 'QR' ||
        payType === 'QRCS' ||
        payType === 'QRPPCS'
      ) {
        setQrPopupOpen(true);
      }
    }
  };

  const handleETaxChange = (event) => {
    setTempETaxChecked(event.target.checked);
    if (!event.target.checked) {
      setDialogOpen(true);
    } else {
      setETaxChecked(event.target.checked);
      setETaxPopupOpen(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const handleDialogTermsClose = () => {
    setDialogTermsOpen(false);
  };

  const handleDialogConfirm = () => {
    setETaxChecked(tempETaxChecked);
    setETaxData(null);
    setDialogOpen(false);
  };
  const handleCloseQrCodePopup = () => {
    // setQrOpen(false);
    setQrPopupOpen(false);
    setSelectedOption('');
  };

  const handleCloseQrPopup = () => {
    setQrOpen(false);
    setSelectedOption('');
  };

  const handleCloseQrCreditPopup = () => {
    setQrCreditOpen(false);
    setSelectedOption('');
  };

  const handleCloseQrAllinOnePopup = () => {
    setQrAllInOneOpen(false);
    setSelectedOption('');
  };

  const handleCloseCreditCardPopup = () => {
    setCreditCardPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseCreditPopup = () => {
    setCreditPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseInternetBankingPopup = () => {
    setInternetBankingPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseBankTransferPopup = () => {
    setBankTransferPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseMobileBankingPopup = () => {
    setMobileBankingPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseWalletPopup = () => {
    setWalletPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseInstallmentPopup = () => {
    setInstallmentPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseRecurringPopup = () => {
    setRecurringPopupOpen(false);
    setSelectedOption('');
    window.location.reload();
  };

  const handleCloseETaxPopup = () => {
    setETaxChecked(false);
    setETaxPopupOpen(false);
  };

  const handleConfirmETaxPopup = (etaxData) => {
    setETaxData(etaxData);
    setETaxPopupOpen(false);
  };

  const paymentOptions = [
    {
      icon: (
        <CreditCardIcon
          style={{
            fontSize: 40,
            marginBottom: '15px',
            marginTop: '15px',
          }}
        />
      ),
      label: 'Credit Card',
      methodName: 'Credit Card',
    },
    // {
    //   icon: (
    //     <AccountBalanceIcon
    //       style={{
    //         fontSize: 40,
    //         marginBottom: '15px',
    //         marginTop: '15px',
    //       }}
    //     />
    //   ),
    //   label: 'Internet Banking',
    //   methodName: 'i-Banking',
    // },
    {
      icon: (
        <QrCodeIcon
          style={{
            fontSize: 40,
            marginBottom: '15px',
            marginTop: '15px',
          }}
        />
      ),
      label: 'QR Code',
      methodName: ['QR Code', 'QR Code Credit Card', 'QR Code - SCB'],
    },
    {
      icon: (
        <LocalAtmIcon
          style={{
            fontSize: 40,
            marginBottom: '15px',
            marginTop: '15px',
          }}
        />
      ),
      label: 'Bank Transfer',
      methodName: 'Upload',
    },
    {
      icon: (
        <PhoneIphoneIcon
          style={{
            fontSize: 40,
            marginBottom: '10px',
            marginTop: '15px',
          }}
          color={isTabletOrLarger ? 'disabled' : 'inherit'}
        />
      ),
      label: 'Mobile Banking',
      disabled: isTabletOrLarger,
      methodName: 'Mobile Banking',
    },
    {
      icon: (
        <AccountBalanceWalletIcon
          style={{
            fontSize: 40,
            marginBottom: '15px',
            marginTop: '15px',
          }}
        />
      ),
      label: 'Wallet',
      methodName: 'Wallet',
    },
    {
      icon: (
        <LocalAtmIcon
          style={{
            fontSize: 40,
            marginBottom: '15px',
            marginTop: '15px',
          }}
        />
      ),
      label: 'Installment',
      methodName: 'Installment',
    },
    {
      icon: (
        <AutorenewIcon
          style={{
            fontSize: 40,
            marginBottom: '15px',
            marginTop: '15px',
          }}
        />
      ),
      label: 'Recurring',
      methodName: 'Recurring',
    },
    {
      icon: (
        <AccountBalanceIcon
          style={{
            fontSize: 40,
            marginBottom: '15px',
            marginTop: '15px',
          }}
        />
      ),
      label: 'Visual Account',
      methodName: 'Visual Account',
    },
  ];

  useEffect(() => {
    if (timeExpired === null) {
      setTimeLeft('');
      return;
    }
    const target = new Date(timeExpired).getTime();

    const timer = setInterval(() => {
      const now = Date.now();
      const distance = target - now;

      if (distance <= 0) {
        clearInterval(timer);
        setTimeLeft(language === 'TH' ? 'หมดเวลาแล้ว' : "Time's up");
        setIsExpired(true);
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((distance / (1000 * 60)) % 60);
        const seconds = Math.floor((distance / 1000) % 60);

        if (language === 'TH') {
          if (days > 0) {
            setTimeLeft(
              `${days} วัน ${hours} ชั่วโมง ${minutes} นาที ${seconds} วินาที`,
            );
          } else {
            setTimeLeft(`${hours} ชั่วโมง ${minutes} นาที ${seconds} วินาที`);
          }
        } else {
          if (days > 0) {
            setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
          } else {
            setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
          }
        }
      }
    }, 1000);
    console.log('Timer ID:', timeLeft);
    return () => clearInterval(timer);
  }, [timeExpired, language]);

  // เรียก API เมื่อหมดเวลา
  useEffect(() => {
    if (isExpired) {
      getData();
    }
  }, [isExpired]);

  return (
    <>
      <Loading isLoading={isLoading} />
      <form
        ref={formMerchant}
        action={urlMerchant.current}
        method="POST"
      ></form>

      <NavbarPaymentOptions
        companyName={companyName}
        companyImage={companyImage}
      />
      <Box
        sx={{
          padding: { xs: '10px', md: '20px' },
          marginTop: '70px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: { xs: '10px', md: '-8px' },
            marginRight: { xs: '2px', md: '1px' },
            alignItems: 'center',
          }}
        >
          <FormControl
            variant="outlined"
            size="small"
            // style={{ minWidth: 120 }}
          >
            {/* <InputLabel>Language</InputLabel> */}
            <Select
              value={language}
              onChange={handleLanguageChange}
              // label="Language"
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={selected === 'TH' ? thailandFlag : ukFlag}
                    alt={selected === 'TH' ? 'Thai Flag' : 'UK Flag'}
                    style={{
                      width: '15px',
                      height: '15px',
                      marginRight: '10px',
                    }}
                  />
                  {selected === 'TH' ? 'ไทย' : 'English'}
                </Box>
              )}
              sx={{
                fontSize: '12px',
                height: '25px',
                padding: '1px 1px 1px 1px',
                width: '110px',
              }}
            >
              <MenuItem value="TH">
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={thailandFlag}
                    alt="Thai Flag"
                    style={{
                      width: '20px',
                      height: '20px',
                      marginRight: '10px',
                    }}
                  />
                  ไทย
                </Box>
              </MenuItem>
              <MenuItem value="EN">
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={ukFlag}
                    alt="UK Flag"
                    style={{
                      width: '20px',
                      height: '20px',
                      marginRight: '10px',
                    }}
                  />
                  English
                </Box>
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            padding: { xs: '10px', md: '10px' },
            // marginTop: '5px',
            marginLeft: { xs: '15px', md: '20px' },
            marginRight: { xs: '15px', md: '20px' },
            paddingBottom: '80px',
          }}
        >
          <Grid container spacing={6}>
            <Grid item xs={12} md={12} lg={8}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '18px',
                  marginTop: '5px',
                }}
              >
                {language === 'TH'
                  ? 'เลือกช่องทางการชำระเงิน'
                  : 'Select Payment Method'}
              </div>
              <Grid container spacing={2}>
                {paymentOptions
                  .filter((option) => {
                    const amount = parseFloat(total.replace(/,/g, ''));
                    const method = paymentMethods.find((method) =>
                      Array.isArray(option.methodName)
                        ? option.methodName.includes(method.name)
                        : method.name === option.methodName,
                    );

                    // ถ้าไม่มี method นี้เลย ไม่แสดง
                    if (!method) return false;

                    // เงื่อนไขไม่ให้แสดง
                    if (
                      (Array.isArray(option.methodName)
                        ? option.methodName.includes('Mobile Banking') &&
                          window.innerWidth >= 768
                        : option.methodName === 'Mobile Banking' &&
                          window.innerWidth >= 768) ||
                      (Array.isArray(option.methodName)
                        ? option.methodName.includes('Installment') &&
                          amount < 3000
                        : option.methodName === 'Installment' && amount < 3000)
                    ) {
                      return false;
                    }

                    return true; // ผ่านทั้งหมด => แสดง
                  })
                  .map((option, index) => {
                    const method = paymentMethods.find((method) =>
                      Array.isArray(option.methodName)
                        ? option.methodName.includes(method.name)
                        : method.name === option.methodName,
                    );

                    return (
                      <Grid item xs={6} md={4} lg={3} key={index}>
                        <Paper
                          elevation={3}
                          sx={{
                            padding: { xs: '15px', md: '25px' },
                            textAlign: 'center',
                            borderRadius: '15px',
                            cursor: 'pointer',
                            border:
                              selectedOption === option.label
                                ? '2px solid #0288d1'
                                : 'none',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                          }}
                          onClick={() => {
                            const bank = method.banks[0];
                            setCheckQR(method);
                            setCheckCredit(method);
                            handleSelectOption(
                              option.label,
                              bank?.bankName,
                              bank?.payType,
                              bank?.fee,
                              bank?.total_amount,
                              bank?.total,
                            );
                          }}
                        >
                          {option.icon}
                          <Typography
                            variant="subtitle1"
                            component="div"
                            fontWeight="bold"
                          >
                            {option.label}
                          </Typography>
                        </Paper>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} lg={4}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '18px',
                  marginTop: '5px',
                }}
              >
                {language === 'TH' ? 'ยอดชำระเงิน' : 'Payment Summary'}
              </div>
              <Paper
                elevation={3}
                sx={{
                  padding: '20px',
                  borderRadius: '15px',
                  border: '1px solid #000',
                }}
              >
                <Box
                  sx={{
                    padding: '10px',
                    textAlign: 'center',
                    borderRadius: '15px',
                  }}
                >
                  <div
                    style={{
                      fontSize: '20px',
                      fontWeight: 'bold',
                      textAlign: 'left',
                      marginBottom: '15px',
                    }}
                  >
                    {language === 'TH' ? 'รายละเอียด' : 'Details'}
                  </div>
                  <Grid container>
                    <Grid item xs={6} md={6}>
                      <div
                        style={{
                          fontSize: '18px',
                          textAlign: 'left',
                          marginBottom: '15px',
                        }}
                      >
                        {language === 'TH' ? ' เลขที่อ้างอิง :' : 'Ref ID :'}
                      </div>
                      <div
                        style={{
                          fontSize: '18px',
                          textAlign: 'left',
                          marginBottom: '15px',
                        }}
                      >
                        {language === 'TH'
                          ? 'ยอดชำระเงิน :'
                          : 'Payment Summary :'}
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div
                        style={{
                          fontSize: '18px',
                          textAlign: 'right',
                          marginBottom: '15px',
                        }}
                      >
                        {orderId}
                      </div>
                      <div
                        style={{
                          fontSize: '18px',
                          textAlign: 'right',
                          marginBottom: '15px',
                        }}
                      >
                        {total}
                      </div>
                    </Grid>

                    <Grid item xs={6} md={6}>
                      {checkQR.name === 'QR Code' ? (
                        checkQR.banks?.length === 1 && (
                          <div
                            style={{
                              fontSize: '18px',
                              textAlign: 'left',
                              marginBottom: '15px',
                            }}
                          >
                            {language === 'TH' ? 'ค่าธรรมเนียม :' : 'Fee :'}
                          </div>
                        )
                      ) : checkCredit.name === 'Credit Card' ? (
                        checkCredit.banks?.length === 1 && (
                          <div
                            style={{
                              fontSize: '18px',
                              textAlign: 'left',
                              marginBottom: '15px',
                            }}
                          >
                            {language === 'TH' ? 'ค่าธรรมเนียม :' : 'Fee :'}
                          </div>
                        )
                      ) : (
                        // ช่องทางอื่น แสดงปกติ
                        <div
                          style={{
                            fontSize: '18px',
                            textAlign: 'left',
                            marginBottom: '15px',
                          }}
                        >
                          {language === 'TH' ? 'ค่าธรรมเนียม :' : 'Fee :'}
                        </div>
                      )}

                      <div
                        style={{
                          fontSize: '20px',
                          fontWeight: 'bold',
                          textAlign: 'left',
                          marginBottom: '15px',
                        }}
                      >
                        {language === 'TH' ? 'รวมทั้งสิ้น :' : 'Summary :'}
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      {checkQR.name === 'QR Code' ? (
                        checkQR.banks?.length === 1 && (
                          <div
                            style={{
                              fontSize: '18px',
                              textAlign: 'right',
                              marginBottom: '15px',
                            }}
                          >
                            {fee}
                          </div>
                        )
                      ) : checkCredit.name === 'Credit Card' ? (
                        checkCredit.banks?.length === 1 && (
                          <div
                            style={{
                              fontSize: '18px',
                              textAlign: 'right',
                              marginBottom: '15px',
                            }}
                          >
                            {fee}
                          </div>
                        )
                      ) : (
                        // ช่องทางอื่น แสดงปกติ
                        <div
                          style={{
                            fontSize: '18px',
                            textAlign: 'right',
                            marginBottom: '15px',
                          }}
                        >
                          {fee}
                        </div>
                      )}

                      <div
                        style={{
                          fontSize: '18px',
                          textAlign: 'right',
                          marginBottom: '15px',
                        }}
                      >
                        {(checkQR.name === 'QR Code' &&
                          checkQR.banks?.length > 1) ||
                        (checkCredit.name === 'Credit Card' &&
                          checkCredit.banks?.length > 1)
                          ? total
                          : totalAmount}
                      </div>
                    </Grid>
                  </Grid>
                  {eTaxStatus === 'true' && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="eTax"
                          color="primary"
                          checked={eTaxChecked}
                          onChange={handleETaxChange}
                        />
                      }
                      label={
                        language === 'TH'
                          ? 'ใบกํากับภาษีอิเล็กทรอนิกส์'
                          : 'E-Tax Invoice'
                      }
                      sx={{
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '5px',
                        '& .MuiFormControlLabel-label': {
                          fontSize: '18px',
                          marginTop: '-2.5px',
                        },
                      }}
                    />
                  )}
                </Box>
              </Paper>
              {timeExpired && (
                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: '10px', justifyContent: 'center' }}
                >
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ marginTop: '5px', marginLeft: '5px' }}
                  >
                    {language === 'TH'
                      ? `กรุณาชำระเงินภายใน ${timeLeft}`
                      : `Please make the payment within ${timeLeft}`}
                  </Typography>
                </Grid>
              )}

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '10px',
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    width: '100%',
                    borderRadius: '10px',
                    fontSize: '16px',
                  }}
                  onClick={handlePaymentClick}
                  disabled={isDisablePay} // Conditionally disable the button
                >
                  {language === 'TH' ? 'ชำระเงิน' : 'Pay'}
                </Button>
              </Box>
              {callCompany && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '20px',
                  }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{
                      width: '100%',
                      borderRadius: '10px',
                      fontSize: '16px',
                    }}
                    onClick={() => {
                      cancel();
                    }}
                  >
                    {language === 'TH'
                      ? 'กลับไปที่ร้านค้า'
                      : 'Back to Merchant'}
                  </Button>
                </Box>
              )}

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '20px',
                  marginBottom: '20px',
                  marginTop: '40px',
                }}
              >
                <div>
                  <img
                    src={pciImage}
                    alt="pciImage"
                    style={{ width: '150px' }}
                  />
                </div>
                <div>
                  <img
                    src={bankofthailandImage}
                    alt="bankofthailandImage"
                    style={{ width: '140px' }}
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <QRCodePopUP
        open={qrPopupOpen}
        onClose={handleCloseQrCodePopup}
        bank={paymentMethods}
        tokens={tokens}
        language={language}
        orderId={orderId}
        paymentRefId={paymentRefId}
        companyName={companyName}
      />
      <QRCode
        open={qrOpen}
        onClose={handleCloseQrPopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
      <QRCredit
        open={qrCreditOpen}
        onClose={handleCloseQrCreditPopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
      <QRAllInOne
        open={qrAllInOneOpen}
        onClose={handleCloseQrAllinOnePopup}
        qrCodeImage={qrCodeImage}
        orderId={orderId}
        paymentRefId={paymentRefId}
        handleRefresh={handlePaymentClick}
        language={language}
        companyName={companyName}
      />
      <CreditCardPopup
        open={CreditCardPopupOpen}
        onClose={handleCloseCreditCardPopup}
        CreditCardImage={CreditCardImage}
        etaxData={etaxData}
        bank={bank}
        tokens={tokens}
        payType={payType}
        language={language}
        dialogTermsOpen={dialogTermsOpen}
      />
      <CreditCardPopUp
        open={creditPopupOpen}
        onClose={handleCloseCreditPopup}
        CreditCardImage={CreditCardImage}
        etaxData={etaxData}
        bank={paymentMethods}
        tokens={tokens}
        payType={payType}
        language={language}
        dialogTermsOpen={dialogTermsOpen}
      />
      <InternetBankingPopup
        open={internetBankingPopupOpen}
        onClose={handleCloseInternetBankingPopup}
        etaxData={etaxData}
        bank={bank}
        tokens={tokens}
      />
      <BankTransferPopup
        open={bankTransferPopupOpen}
        onClose={handleCloseBankTransferPopup}
        etaxData={etaxData}
        tokens={tokens}
        paymentRefId={paymentRefId}
        bankImage={bankImage}
        nameAccount={nameAccount}
        accountNumber={accountNumber}
        totalAmount={totalAmount}
        language={language}
      />
      <MobileBankingPopup
        open={mobileBankingPopupOpen}
        onClose={handleCloseMobileBankingPopup}
        etaxData={etaxData}
        bank={bank}
        tokens={tokens}
        payType={payType}
        language={language}
      />
      <WalletPopup
        open={walletPopupOpen}
        onClose={handleCloseWalletPopup}
        WalletImage={WalletImage}
        etaxData={etaxData}
        bank={bank}
        tokens={tokens}
        language={language}
      />
      <InstallmentPopup
        open={installmentPopupOpen}
        onClose={handleCloseInstallmentPopup}
        InstallmentImage={InstallmentImage}
        etaxData={etaxData}
        bank={paymentMethods}
        tokens={tokens}
        language={language}
        totalAmount={totalAmount}
      />
      <RecurringPopup
        open={recurringPopupOpen}
        onClose={handleCloseRecurringPopup}
        // RecurringImage={RecurringImage}
        etaxData={etaxData}
        bank={bank}
        tokens={tokens}
        language={language}
      />
      <ETaxPopup
        open={eTaxPopupOpen}
        onClose={handleCloseETaxPopup}
        onConfirm={handleConfirmETaxPopup}
        etaxData={etaxData}
        language={language}
      />

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '500px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
              marginTop: '20px',
            }}
          >
            {language === 'TH'
              ? 'คุณไม่ต้องการที่จะรับใบกำกับภาษีอิเล็กทรอนิกส์'
              : `You don't want to receive electronic invoices`}{' '}
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '17px',
            marginTop: '18px',
          }}
        >
          {language === 'TH'
            ? 'คุณไม่ต้องการที่จะรับใบกำกับภาษีอิเล็กทรอนิกส์'
            : `You don't want to receive electronic invoices`}
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '18px',
            marginBottom: '20px',
          }}
        >
          <Button
            onClick={handleDialogClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยกเลิก' : `Cancel`}
          </Button>
          <Button
            onClick={handleDialogConfirm}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',

              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
            autoFocus
          >
            {language === 'TH' ? 'ยืนยัน' : `Submit`}
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog
        open={dialogTermsOpen}
        onClose={handleDialogTermsClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '650px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
              fontSize: '20px',
              mt: 2,
            }}
          >
            {language === 'TH' ? 'ข้อกำหนดและเงื่อนไข' : 'Terms and Conditions'}
          </Box>
        </DialogTitle>

        <DialogContent
          sx={{
            fontSize: '17px',
            mt: 2,
            mx: 2,
            border: '1px solid #ccc',
            borderRadius: '8px',
            p: 2,
            backgroundColor: '#f9f9f9',
            textAlign: 'center',
            lineHeight: 1.6,
          }}
        >
          {language === 'TH' ? (
            <>
              <br />
              เพื่อเพิ่มความปลอดภัยในการทำธุรกรรมออนไลน์ของคุณ <br />
              กรุณาเปิดใช้งานระบบ 3D Secure (Verified by Visa/Mastercard) <br />
              กับธนาคารผู้ออกบัตรของท่านก่อนทำธุรกรรม
              <br />
            </>
          ) : (
            <>
              <br />
              To enhance the security of your online transactions, please
              activate 3D Secure (Verified by Visa/Mastercard) with your card
              issuer before continuing
              <br />
            </>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 2,
            mb: 2,
          }}
        >
          <Button
            onClick={handleDialogTermsClose}
            sx={{
              width: 100,
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ปิด' : 'Close'}
          </Button>
        </DialogActions>
      </Dialog> */}

      <footer
        style={{
          textAlign: 'center',
          padding: '5px',
          background: '#0288d1',
          color: '#fff',
          position: 'fixed',
          left: '0',
          bottom: '0',
          width: '100%',
          borderTop: '1px solid #e7e7e7',
        }}
      >
        <Typography variant="body2" color="inherit" component="p">
          © Copyright 2024, Internet Thailand Public Company Limited. |
          <a
            href="/terms"
            style={{ color: '#fff', marginLeft: '5px', marginRight: '5px' }}
          >
            TERM AND CONDITION
          </a>
          |
          <a
            href="/privacy"
            style={{ color: '#fff', marginLeft: '5px', marginRight: '5px' }}
          >
            PRIVACY POLICY
          </a>
        </Typography>
      </footer>
    </>
  );
}

export default PaymentOptions;
